const getPrintNumberFromTokenId = (tokenId) => parseInt(`${tokenId}`.substring(5, 8), 10);

export default getPrintNumberFromTokenId;
